var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.095 466.813C384.955 470.188 384.548 475.219 381.189 478.094C379.689 479.375 377.845 480 376.001 480C373.736 480 371.501 479.031 369.908 477.188L192 268.349L14.092 477.188C12.499 479.031 10.264 480 7.999 480C6.155 480 4.311 479.375 2.811 478.094C-0.548 475.219 -0.955 470.188 1.905 466.813L181.486 256.005L1.905 45.197C-0.955 41.822 -0.548 36.791 2.811 33.916C6.171 31.041 11.186 31.448 14.092 34.823L192 243.662L369.908 34.823C372.814 31.448 377.861 31.041 381.189 33.916C384.548 36.791 384.955 41.822 382.095 45.197L202.514 256.005L382.095 466.813Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.55f770831cea8bedbbcf985dd054f15f.svg";
export { ForwardRef as ReactComponent };